import pkg from 'use-sync-external-store/shim/index.js';
export const useSyncExternalStore = pkg.useSyncExternalStore;